
    export enum EnumJobFunction {
			Accounting = 0,
			Contacts = 1,
			Customer = 2,
			CustomerAdmin = 3,
			Financial = 4,
			GroupLeader = 5,
			GPC = 6,
			IngredientDept = 7,
			InHouseManager = 8,
			InHouseMISmanager = 9,
			LOC = 10,
			LocScheduleAandB = 11,
			LocScheduleABandIA = 12,
			LocScheduleABandPA = 13,
			LocScheduleABIAandPA = 14,
			Management = 15,
			Mashgiach = 16,
			NewKashrusUser = 17,
			OUIsraelStaff = 18,
			ProductDept = 19,
			ProductDepartmentSupervisor = 20,
			RabbinicCoordinator = 21,
			RCSupportStaff = 22,
			RFR_PartTime = 23,
			ScheduleAandB = 24,
			ScheduleABandIA = 25,
			ScheduleABandPA = 26,
			ScheduleABIAandPA = 27,
			SeniorRfr = 28,
			Supplier = 29,
			SupplierNoUKD = 30,
			UkdApplicationTms = 31,
			Temporary = 32,
			UkdOnly = 33,
			Any = 34,
			RfrTeamLeader = 35,
    }